import React, { useEffect, useState, Fragment, Button } from 'react'
import BootstrapTable from 'react-bootstrap-table-next'


const Requisitos = ({requisitos, recargarRequisitos}) => {

    const [selected, setSelected]=useState([])

    const recargar = async () => {
        recargarRequisitos();
    };

    const columns=[ {
        dataField: 'nombre',
        text: `Valida Requisitos (Pendientes ${requisitos && requisitos.length - selected.length} )`,
        headerEvents: {
          onClick: (e, column, columnIndex) => recargar()
        },
        headerFormatter: (cell, row) => {
          return formatter();
        }
      }
    ];
    const formatter = () => {
      return (
        <div>
          Valida Requisitos (Pendientes {requisitos && requisitos.length - selected.length}) 
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" style={{cursor:'pointer'}} viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
              <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
          </svg>
        </div>
      )
    }
    useEffect (()=> {
      if (requisitos && requisitos.length !== undefined) {
        const opciones = requisitos.filter(r=>(r.folioCarga > 0 ))
        setSelected(opciones.map(r=>(r.id )))
      }
    },[requisitos])
    
    const selectRow = {
        mode: 'checkbox',       
        selected: selected,
        nonSelectable: [1,2, 3 ,4,5,6,7,8,9,10,11,12,13,14,15,16],       
        hideSelectAll: true       
    };
    return (
        <>
        <div>
            {
                requisitos && (
                <BootstrapTable
                    keyField="id"
                    data={requisitos}
                    columns={ columns }
                    selectRow={ selectRow }                
                />
                )
            }
        </div>            
        </>
    )
}
export default Requisitos